import { graphql, useStaticQuery } from "gatsby"

const useBrandInfo = () => {
  const data = useStaticQuery(graphql`
    query {
      strapiSiteConfig {
        brand_name
        email
        facebook_link
        instagram_link
        linkedin_link
        orn_no
        phone
        twitter_link
        youtube_link
        telegram_link
        whatsapp
        address {
          data {
            address
          }
        }
        cp_email
        #london_phone
      }
    }
  `)

  const {
    brand_name,
    email,
    facebook_link,
    instagram_link,
    linkedin_link,
    orn_no,
    phone,
    whatsapp,
    twitter_link,
    youtube_link,
    telegram_link,
    address,
    cp_email,
    london_phone
  } = data.strapiSiteConfig
  return {
    name: brand_name,
    email,
    facebookLink: facebook_link,
    instagramLink: instagram_link,
    linkedinLink: linkedin_link,
    ornNo: orn_no,
    phone,
    whatsapp,
    twitterLink: twitter_link,
    youtubeLink: youtube_link,
    telegramLink: telegram_link,
    whatsapp,
    cp_email: cp_email,
    address:address,
    london_phone: london_phone
  }
}

export default useBrandInfo
